import React from "react";
import { SovosGrid, SovosIcon, SovosTypography } from "mosaic-react";
import { CircleRounded } from "mosaic-react-icons";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { ActionButtonOutlined } from "../../../DetailPanels/GeneratorListDetails/ActionButtonOutlined";

const GeneratorDataProvide = (props) => {
    const { i18n } = useGlobalValue();
    const { value: cell } = props || {};
    const { status: isFileExists, isMandatory, history } = cell || {};

    if (typeof isFileExists === "undefined" || isFileExists === null) {
        return (
            <SovosTypography
                sx={{ textAlign: "left", flexGrow: "1", fontSize: "12px" }}
            >{i18n`Unchecked`}</SovosTypography>
        );
    }

    const _color = isFileExists ? "success" : "error";

    return (
        <SovosGrid
            sx={{
                display: "flex",
                justifyContent: "flex-start",
                flexGrow: "0",
                alignItems: "center",
                minWidth: "150px",
            }}
        >
            <SovosIcon color={_color} sx={{ marginRight: "10px", fontSize: "12px" }}>
                <CircleRounded sx={{ 
                    color: _color, 
                    fontSize: "12px", 
                    position: "relative", 
                    left: "50%", 
                    //top: "50%", 
                    transform: "translate(-50%, -50%)" }} />
            </SovosIcon>
            {isMandatory ? 
                <SovosTypography variant="body1" sx={{ fontSize: "12px" }}>{isFileExists ? i18n`Provided` : ""}</SovosTypography>
                : <SovosTypography variant="body1" sx={{ fontSize: "12px" }}>{isFileExists ? i18n`Provided` : i18n`Missed`}</SovosTypography>
            }

            {!isFileExists && isMandatory && (
                <ActionButtonOutlined
                    i18n={i18n}
                    link={`activity`}
                    title={"Upload missing data"}
                    history={history}
                    sx={{ margin: "0px !important", padding: "0px !important", fontSize: "12px" }}
                />
            )}
        </SovosGrid>
    );
};

export default GeneratorDataProvide;
